import React, { useState } from 'react';
import Button from '@jbhi-fi/lanyard-ui/components/Button';
import TextField, { InputModeType, InputType } from '@jbhi-fi/lanyard-ui/components/TextField';
import { styles } from './SubscribeBanner.css';
import { palette } from '@jbhi-fi/lanyard-ui/themes';
import { useSubscribe as useSubscribeDefault, UseKlaviyoSubscribe } from '../../hooks/useKlaviyoSubscribe';
import CalloutFont from '@jbhi-fi/lanyard-ui/font/CalloutFont';

export type SubscribeBannerProps = {
  enabled: boolean;
  mailingListId: string;
  offerText?: string;
  disclaimer?: string;
  privacyLink?: string;
  useSubscribe?: UseKlaviyoSubscribe;
};
const PRIVACY_URL =
  'https://support.jbhifi.com.au/hc/en-au/articles/360052938974?_ga=2.113799687.1491774675.1667775136-1224187721.1667444203&_gac=1.93656815.1667971174.Cj0KCQjw94WZBhDtARIsAKxWG-9E33Vl_DKgMVGKdqbY2ztnXN46SX8pLxuvZFEjaRuknqkB7K8CCukaAkTeEALw_wcB&_gl=1*1fbq95a*_ga*MTIyNDE4NzcyMS4xNjY3NDQ0MjAz*_ga_7P0V78MR2P*MTY2ODEzOTUxNS4xOC4xLjE2NjgxMzk1MTguMC4wLjA.';

export const SubscribeBanner = ({
  offerText,
  disclaimer,
  mailingListId,
  privacyLink,
  useSubscribe = useSubscribeDefault,
}: SubscribeBannerProps) => {
  const { message, isLoading, hasError, onSubscribe } = useSubscribe();
  const [email, setEmail] = useState('');
  const handleInputChange = (value: string) => {
    setEmail(value);
  };
  const handleSubmit = async (e: any) => {
    e.preventDefault();
    await onSubscribe({ email, listId: mailingListId });
  };

  return (
    <div className={styles.subscribeContainer}>
      <div className={styles.bannerContent}>
        {offerText ? (
          <div className={styles.tagLine}>
            <CalloutFont>{offerText}</CalloutFont>
          </div>
        ) : null}
        <div className={styles.subscribeInput}>
          <form className={styles.inputsGroup} onSubmit={handleSubmit}>
            <TextField
              id={'subscribe-input'}
              name="subscribe-input"
              placeholder="Enter your email"
              type={InputType.email}
              value={email}
              inputMode={InputModeType.email}
              className={styles.input}
              onChange={e => handleInputChange(e.target.value)}
              hasError={hasError}
            />
            <Button type="primary" label="Subscribe" onClick={handleSubmit} loading={isLoading} />
          </form>
          <div className={styles.messagesWrapper}>
            {message ? (
              <div className={styles.message} style={{ color: hasError ? palette.error.main : palette.primary.dark }}>
                {message}
              </div>
            ) : null}
          </div>
          {disclaimer ? (
            <div className={styles.disclaimerText}>
              {disclaimer}
              <a href={privacyLink || PRIVACY_URL}>
                <span>privacy policy.</span>
              </a>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};
